import React from 'react'
import { Link } from 'react-router-dom';
import paths from '../../routes/paths';
import { imageCodes, titleCodes, textCodes } from '../../template_codes/phyohandmade/home_page_codes';
import { useState } from "react";

export default function Home() {

    const [toggleState, setToggleState] = useState(1);
    const toggleTab = (index) => {
        setToggleState(index);
    }
    console.log('toggle', toggleState)
    return (
        <div>
            <div className='text-center pt-20 pb-5'>
                <h1 className="text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold">Phyo's Handmade</h1>
            </div>

            {/*                         banner                      */}

            <div className='container w-full'>
                <img src={imageCodes.banner.image}></img>
            </div>

            {/*                     end of banner                    */}


            {/*                         About us                     */}

            <div className='container w-4/5 text-center pt-10'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>{titleCodes.About.title}</h1>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-center'>{textCodes.text.text}</p>
            </div>

            {/*                   end of about us                     */}

            {/*                         favourite                     */}

            <div className='container w-4/5 text-center pt-10'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>{titleCodes.Fav.title}</h1>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-center'>{textCodes.ourfav.text}</p>

            </div>

            {/*                         tab                          */}
            <div className="container lg:w-4/5 xl:w-4/5 2xl:4/5 pt-10">
                <div className="tabs place-content-center">
                    <div
                        className={toggleState === 1 ? "tab tab-bordered active-tab" : "tab"}
                        onClick={() => toggleTab(1)}
                    ><h1 className='font-bold text-md lg:text-xl xl:text-xl 2xl:text-xl'>Best Seller</h1></div>
                    <div className={toggleState === 2 ? "tab tab-bordered active-tab" : "tab"}
                        onClick={() => toggleTab(2)}
                    ><h1 className='font-bold text-md lg:text-xl xl:text-xl 2xl:text-xl'>New Arrivals</h1></div>
                    <div
                        className={toggleState === 3 ? "tab tab-bordered active-tab" : "tab"}
                        onClick={() => toggleTab(3)}
                    ><h1 className='font-bold text-md lg:text-xl xl:text-xl 2xl:text-xl'>Sales</h1></div>
                </div>
                <div className="tab-content pt-10">
                    {toggleState === 1 &&
                        <div
                            className={"tab-content active-tab-content"}
                        >
                            <div className='row'>
                                <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 2xl:grid-cols-6'>
                                    <img src={imageCodes.BestImage.image} alt="category"></img>
                                    <img src={imageCodes.BestImage1.image} alt="category"></img>
                                    <img src={imageCodes.BestImage2.image} alt="category"></img>
                                    <img src={imageCodes.BestImage3.image} alt="category"></img>
                                    <img src={imageCodes.BestImage4.image} alt="category"></img>
                                    <img src={imageCodes.BestImage5.image} alt="category"></img>
                                </div>
                            </div>
                            <div className='row'>

                            </div>
                        </div>
                    }
                    {toggleState === 2 && <div
                        className={"tab-content active-tab-content"}
                    >
                        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 2xl:grid-cols-6'>
                            <img src={imageCodes.NewArival.image} alt="category"></img>
                            <img src={imageCodes.NewArival1.image} alt="category"></img>
                            <img src={imageCodes.NewArival2.image} alt="category"></img>
                            <img src={imageCodes.NewArival3.image} alt="category"></img>
                            <img src={imageCodes.NewArival4.image} alt="category"></img>
                            <img src={imageCodes.NewArival5.image} alt="category"></img>
                        </div>
                    </div>
                    }
                    {toggleState === 3 && <div
                        className={"tab-content active-tab-content"}
                    >
                        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 xl:grid-cols-6 2xl:grid-cols-6'>
                            <img src={imageCodes.Sale.image} alt="category"></img>
                            <img src={imageCodes.Sale1.image} alt="category"></img>
                            <img src={imageCodes.Sale2.image} alt="category"></img>
                            <img src={imageCodes.Sale3.image} alt="category"></img>
                            <img src={imageCodes.Sale4.image} alt="category"></img>
                            <img src={imageCodes.Sale5.image} alt="category"></img>
                        </div>
                    </div>
                    }
                </div>
            </div>

            {/*                                 end of tab                           */}



            {/*                               end of favourite                         */}

            {/*                               feature product                         */}
            <div className='container w-4/5 text-center pt-10'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>{titleCodes.Feat.title}</h1>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-center'>{textCodes.ourfav.text}</p>

            </div>

            <div className='container w-4/5'>
                <div className="carousel carousel-center lg:carousel-center xl:carousel-center 2xl:carousel-center">
                    <div className="carousel-item">
                        <img src={imageCodes.FeaImage.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.FeaImage1.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.FeaImage2.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.FeaImage3.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.FeaImage4.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.FeaImage5.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.FeaImage3.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.FeaImage2.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                </div>
            </div>

            {/*                     end of feature product              */}

            {/*                     scan and tag                        */}
            <div className='container w-4/5 text-center pt-10 pb-5'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>{titleCodes.SandT.title}</h1>

            </div>

            <div className='container'>
                <div className="carousel carousel-center lg:carousel-center xl:carousel-center 2xl:carousel-center">
                    <div className="carousel-item">
                        <img src={imageCodes.Sale5.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.Sale.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.Sale1.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.Sale2.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.Sale3.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.Sale4.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.Sale.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                    <div className="carousel-item">
                        <img src={imageCodes.Sale3.image} className="rounded-box w-48 h-48 place-items-center" />
                    </div>
                </div>
            </div>
            {/*                  end of scan and tag                 */}

            {/*                     room                        
            <div className='container p-10 w-fix'>
                <div className="container grid grid-cols-1 xl:grid-cols-2 gap-4 pt-10 w-5/6 h-4/6">
                    <div className='container-center'>
                        <img src={imageCodes.Artisan.image} width={400} height={400} />
                    </div>
                    <div className='container-center'>
                        <img src={imageCodes.scantag.image} width={400} height={400} />
                    </div>
                </div>

            </div>
             room                         */}

            {/*                     pop up store                 */}
            <div className='container w-4/5 text-center pt-10 pb-10'>
                <h1 className='text-xl lg:text-2xl xl:text-2xl 2xl:text-2xl font-bold'>{titleCodes.Popup.title}</h1>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-center'>{textCodes.pop.text}</p>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-center'>{textCodes.pop1.text}</p>
                <p className='px-1 text-sm lg:text-lg xl:text-lg 2xl:text-lg lg:px-40 xl:px-40 pt-5 text-center'>{textCodes.pop2.text}</p>
            </div>
            {/*                 end of pop up store              */}

            <div class="grid grid-cols-4 gap-2 lg:gap-0 xl:gap-0 2xl:gap-0 place-content-center container lg:w-4/6 xl:w-4/6 2xl:w-4/6 text-center pb-10">
                <div></div>
                <div><button className="btn btn-outline pl-5 xl:pl-20 2xl:pl-20 text-center xl:pr-20 2xl:pr-20"><a href='https://phyohandmade.com/'>Shop</a></button></div>
                <div><button className="btn btn-outline xl:pl-20 2xl:pl-20 text-center xl:pr-20 2xl:pr-20"><Link to={paths.contact}>Contact</Link></button></div>
                <div></div>

            </div>
            
        </div>
    );
}
